import React, { useEffect, useState } from "react";
import AdminProgramming from '../../Data/Admin/Programming.json';
import { Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faXmark, faPenToSquare, faEye,faArrowLeftLong} from '@fortawesome/free-solid-svg-icons';
import { programListByEvent, getProgramEyeView, deleteProgram } from '../../Service';
import { useParams } from "react-router";
import Swal from "sweetalert2";

export default function AdminProgram(){

    const [perPage, setPerPage] = useState(100);
    const [curPage, setCurPage] = useState(1);
    const [list, setList] = useState([]);
    const [eventname, setEventname] = useState([]);
    const { id } = useParams();
    const event_id  = id;
    const [currentItems, setCurrentItems] = useState([]);
    
    useEffect(() => {
        let params = { 'fair': event_id,'perPage': perPage, 'curPage': curPage };
        console.log('params',params)
        programListByEvent(params).then(res => handleResponse(res))
      }, [curPage]);

      const handleResponse = (response) => {
        setEventname(response.data.data);
        setList(response.data.data.program.items);
      }

      const handleEyeClick =(proid) => {
      let program_id=proid;
      let params={program_id:proid};
      getProgramEyeView(params).then(res => handleProgramResponse(res))
    }

    const handleProgramResponse = (response) => {
console.log('log 37', process.env.REACT_APP_API_STORAGE+(response.data.data.item.cover_image))
        Swal.fire({
            title: '<strong>'+response.data.data.item.title+'</strong>',
            html:
            'Date : '+response.data.data.item.date +'</br> ' +
            'Start time : '+response.data.data.item.start_time+'</br> ' +
            'End time : '+response.data.data.item.end_time+'</br> ' +
            'Type : '+response.data.data.item.type+'</br> ' +
            'Description: '+response.data.data.item.description+'</br> ' +
            'Zoom Link: '+response.data.data.item.zoom_link+'</br> ' +
              '',
            imageUrl: process.env.REACT_APP_API_STORAGE+response.data.data.item.cover_image,
            showCloseButton: true,
            //showCancelButton: true,
            //focusConfirm: false,
            //confirmButtonText:
           //   '<i class="fa fa-thumbs-up"></i> Great!',
           // confirmButtonAriaLabel: 'Thumbs up, great!',
            // cancelButtonText:
            //   '<i class="fa fa-thumbs-down"></i>',
           // cancelButtonAriaLabel: 'Thumbs down'
          })
        
      }

      localStorage.setItem('program_by_event', eventname.event_name);

      const doDelete = (prom_id)=> {
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want delete this event?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
                let program_id=prom_id;
                let params = { id : prom_id };
                deleteProgram(params).then(res => handleDeleteRes(res,prom_id))
            }
          })
        
    }

    const handleDeleteRes = (response, prom_id) => {
        console.log(response);
        if(response.data.code==400){ //IF Token Expired......
            const errors = {};
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.message,
            })
          }else if(response.data.code==200){  //IF Request is Success
            let allEventData = list;
            let filteredArray =  allEventData.filter(item => item.id !== prom_id);
            setList(filteredArray);
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Program Deleted Successfully',
                showConfirmButton: false,
                timer: 1500
              })
          }
      }

    

return(
<section className="admin-section">
<div className="container">
<div className="row">
<div className="col-12">
<div className="card admin-table"> 
    <div className="card-header">
    <h1>PROGRAMMING</h1>
    <Link to={"/createprogramming/"+event_id} className="add-event">+ Add New</Link>   
    </div>
    <div className="card-body">
    <div class="row">
        <div class="col-md-4"><Link to="/eventlist"><h1><FontAwesomeIcon icon={faArrowLeftLong} /></h1> </Link></div>
        <div class="col-md-4"><h2>{eventname.event_name}</h2></div>
    </div>
    
    
        <div className="table-responsive">
        <table className="table">
            <thead>
                <tr>
                    <th>Title</th>
                    <th>Date</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>PROGRAM TYPE</th>
                    <th>Details</th>
                    <th> </th>
                </tr>
            </thead>
            <tbody>
            { list.length ?
                    list.map( data => (
                        <tr key={data}>
                            <td>{data.title}</td>
                            <td>{data.date}</td>
                            <td>{data.start_time}</td>
                            <td>{data.end_time}</td>
                            <td>{data.type}</td>
                            <td className="admin-editdelete">
                            <Link to="#"><FontAwesomeIcon icon={faEye} onClick={()=> handleEyeClick(data.id)}   /></Link> &nbsp; / &nbsp;  
                            <Link to={"/editprogramming/"+data.id+"/"+id}><FontAwesomeIcon icon={faPenToSquare} /></Link></td>  
                            <td className="table-close">
                            <Link to="#"><FontAwesomeIcon icon={faXmark} onClick={()=> doDelete(data.id)} /></Link>
                            </td>
                        </tr> 
                    )) :

                    <tr colSpan={7}> <p>No Record Found</p></tr>
                }
                
            </tbody>
        </table> 
        </div>
    </div>

</div>
</div>
</div>
</div>  
</section>
)
}
